// Excel-style column resize. Usage on any table: v-resizable-columns="'some-table-id'"
// Widths are kept in localStorage per table id + column title. App.vue logOut() clears localStorage.
export default {
  mounted(el, binding) {
    const storeKey = 'icc-colw:' + binding.value;
    let widths = {};
    try { widths = JSON.parse(localStorage.getItem(storeKey) || '{}') || {}; } catch (e) { widths = {}; }
    const MIN = 60;
    let raf = 0;
    let lastDrag = 0;
 
    const getTable = () => (el.tagName === 'TABLE' ? el : el.querySelector('table'));
    const labelOf = (th) => {
      const t = th.querySelector('.title-container span');
      return ((t ? t.textContent : th.textContent) || '').trim();
    };
    const setColWidth = (table, index, w) => {
      table.querySelectorAll(':scope > thead > tr, :scope > tbody > tr, :scope > tr').forEach((row) => {
        const cell = row.querySelectorAll(':scope > th, :scope > td')[index];
        if (!cell || cell.colSpan > 1) return;
        cell.style.width = w + 'px';
        cell.style.minWidth = w + 'px';
        cell.style.maxWidth = w + 'px';
        if (cell.tagName === 'TD') {
          cell.style.overflow = 'hidden';
          cell.style.textOverflow = 'ellipsis';
          cell.style.whiteSpace = 'nowrap';
        }
      });
    };
    const startDrag = (e, table, th) => {
      e.preventDefault();
      e.stopPropagation();
      const handle = e.currentTarget;
      handle.setPointerCapture(e.pointerId);
      const label = labelOf(th);
      const idx = Array.prototype.indexOf.call(th.parentNode.children, th);
      const startX = e.clientX;
      const startW = th.getBoundingClientRect().width;
      handle.classList.add('active');
      const move = (ev) => {
        const w = Math.max(MIN, Math.round(startW + (ev.clientX - startX)));
        widths[label] = w;
        setColWidth(table, idx, w);
      };
      const up = () => {
        handle.removeEventListener('pointermove', move);
        handle.removeEventListener('pointerup', up);
        handle.removeEventListener('pointercancel', up);
        handle.classList.remove('active');
        lastDrag = Date.now();
        try { localStorage.setItem(storeKey, JSON.stringify(widths)); } catch (err) { console.warn('Could not save column widths', err); }
      };
      handle.addEventListener('pointermove', move);
      handle.addEventListener('pointerup', up);
      handle.addEventListener('pointercancel', up);
    };
    const apply = () => {
      const table = getTable();
      if (!table) return;
      table.querySelectorAll(':scope > thead > tr > th, :scope > tr:first-child > th, :scope > tbody > tr:first-child > th')
        .forEach((th) => {
          const label = labelOf(th);
          if (!label) return; // skips the select-all checkbox column
          if (!th.querySelector(':scope > .icc-col-resizer')) {
            if (getComputedStyle(th).position === 'static') th.style.position = 'relative';
            const h = document.createElement('span');
            h.className = 'icc-col-resizer';
            h.addEventListener('pointerdown', (e) => startDrag(e, table, th));
            th.appendChild(h);
          }
          if (widths[label]) {
            setColWidth(table, Array.prototype.indexOf.call(th.parentNode.children, th), widths[label]);
          }
        });
    };
    const schedule = () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(apply); };
 
    // never let the end of a drag count as a click (sorting / filter)
    el.addEventListener('click', (e) => {
      if (Date.now() - lastDrag < 300) { e.stopPropagation(); e.preventDefault(); }
    }, true);
 
    const mo = new MutationObserver(schedule); // childList only, so style changes do not loop
    mo.observe(el, { childList: true, subtree: true });
    el._iccResize = { mo };
    schedule();
  },
  unmounted(el) {
    if (el._iccResize) el._iccResize.mo.disconnect();
  },
};